<template>
  <tr v-on:click="joinGame">
    <td>{{name}}</td>
    <td class="text-end creator">{{game.creator}}</td>
    <td class="text-end now" v-if="game.startDate && activeRound < 1">
      Débute bientôt
    </td>
    <td class="text-end" v-if="game.startDate && activeRound >= 1">{{activeRound}}</td>
    <td class="text-end" v-if="!game.startDate">-</td>
    <td class="text-end" v-if="game.startDate">{{startDate}}</td>
    <td class="text-end now" v-else>En préparation</td>
    <td class="text-end" v-if="game.endDate">{{endDate}}</td>
    <td class="text-end" v-else>-</td>
    <td class="text-end" v-bind:title="playersList">
      {{players.length}}
      <img src="/static/people.svg" height="20"/></td>
    <td class="text-end" v-if="game.roundTime">{{roundTime}}
      <img src="/static/alarm.svg" height="20"/></td>
    <td class="text-end" v-else>-</td>
    <td>
      <div class="row" v-if="game.locked">
        <div class="col-12">
          <form v-on:submit="joinGame">
            <div>
              <div class="input-group">
                <div class="input-group-text lock">&#x1F512;</div>
                <input type="text" class="form-control"
                maxlength="70"
                placeholder="Clé d'accès..." v-model="gamePassword">
              </div>
            </div>
          </form>
        </div>
      </div>
      <div v-if="game.onlyFriends">
        <img src="/static/lock-alt.svg" width="20"/>
        Amis seulement !
      </div>
    </td>
    <td class="text-center">
      <button v-bind:class="buttonClass">
        JOUER
      </button>
    </td>
    <td class="text-center">
      <button v-bind:class="buttonClass" v-on:click="viewGame"
        v-if="!game.locked && !game.onlyFriends && game.startDate">
        <font-awesome-icon icon="eye" class="icon"/>
        voir
      </button>
    </td>
  </tr>
</template>

<script>
import iam from '../iam';

const padZero = n => ((n < 10) ? `0${n}` : n);
const convertDate = (timestamp) => {
  const h = padZero(new Date(Date.parse(timestamp)).getHours());
  const m = padZero(new Date(Date.parse(timestamp)).getMinutes());
  return `${h}h${m}`;
};

export default {
  name: 'AccessGameList',
  props: {
    game: {
      type: Object,
      required: true,
    },
    players: {
      type: Array,
      required: true,
    },
  },
  computed: {
    name() {
      return this.game.gameName;
    },
    activeRound() {
      const now = new Date();
      return Math.min(Math.ceil(
        (now.getTime() - Date.parse(this.game.startDate)) / (1000 * this.game.roundTime)),
      this.game.nbRounds);
    },
    startDate() {
      return convertDate(this.game.startDate);
    },
    endDate() {
      return convertDate(this.game.endDate);
    },
    roundTime() {
      if (this.game.roundTime < 120) {
        return `${this.game.roundTime} s`;
      }
      return `${this.game.roundTime / 60} min`;
    },
    buttonClass() {
      return {
        btn: true,
        'btn-link': true,
        inactive: this.game.locked && !this.gamePassword,
        active: !this.game.locked || this.gamePassword,
      };
    },
    playersList() {
      return this.players.reduce((acc, player, index) => (index === this.players.length - 1 ? `${acc}${player.username}` : `${acc}${player.username}, `), '');
    },
  },
  data() {
    return {
      gamePassword: undefined,
    };
  },
  methods: {
    joinGame(event) {
      event.preventDefault();
      if (this.game.locked && !this.gamePassword) {
        return;
      }
      this.$http.post(`${import.meta.env.VITE_LCT_API_URL}/game-players`, {
        username: iam.getConnectedUser().username,
        picture: iam.getConnectedUser().picture,
        password: this.game.locked ? this.gamePassword : undefined,
        activeGameId: this.game.id,
      }).then((response) => {
        sessionStorage.setItem(`${this.game.id}`, `${response.data.id}`);
        if (!this.game.startDate) {
          this.$router.push(`/prepare-games/${this.game.id}`);
        } else {
          this.$router.push(`/games/${this.game.id}`);
        }
      });
    },
    viewGame(event) {
      event.preventDefault();
      event.stopPropagation();
      if (this.game.locked) {
        return;
      }
      this.$router.push(`/view/games/${this.game.id}`);
    },
  },
};
</script>

<style scoped>
.table-hover tr{
  cursor: pointer;
}
.table-hover tr:hover {
  background-color: rgba(59, 247, 182, 0.075);
}
.inactive{
  color: #757575;
}
.inactive:hover{
  color: #757575;
  text-decoration: none;
}
.active{
  color: #CE0F69;
}
td img{
  vertical-align: sub;
}
.creator{
  color: #757575;
}
.now{
  color: #CE0F69;
}
.btn {
  padding: 0;
}
.input-group{
  width: 200px;
}
</style>
